(ns io.daskul.tutorial.webapp.domain.active-context.subs
  "Active context subscriptions — current branch/school selection (F-041)."
  (:require
   [re-frame.core :as rf]
   [io.daskul.tutorial.webapp.domain.auth.subs :as auth.subs]))

(rf/reg-sub
 ::branch-id
 (fn [db _]
   (get-in db [:active-context :branch-id])))

(rf/reg-sub
 ::school-id
 (fn [db _]
   (get-in db [:active-context :school-id])))

;; Available contexts from JWT (for branch picker UI)
(rf/reg-sub
 ::available-contexts
 :<- [::auth.subs/current-user]
 (fn [user _]
   (:available-contexts user)))

;; SMS-49: tz for the *active* school — used by the calendar to render
;; block times in the school's tz regardless of the browser's tz. Falls
;; back to "Asia/Manila" so the calendar always has a usable value (e.g.
;; on first-render before the JWT-driven context resolves).
(rf/reg-sub
 ::school-timezone
 :<- [::school-id]
 :<- [::auth.subs/school-timezones]
 (fn [[school-id tzs] _]
   (or (get tzs (keyword (str school-id)))
       (get tzs (str school-id))
       "Asia/Manila")))

;; #715: the set of lowercase day names the ACTIVE context is open on.
;;
;; On a specific branch, that branch's days. On "All Branches" (branch-id
;; nil) the UNION across everything the user can see — a day is shown if any
;; of their branches operates on it, since the grid is showing all of them at
;; once and hiding a day would hide another branch's sessions.
;;
;; nil when the claim is absent (an older token, or first render before auth
;; resolves), which `cal/visible-week-days` reads as "render every day".
;; Open-by-default is the rule at every layer of this feature.
(rf/reg-sub
 ::open-day-names
 :<- [::branch-id]
 :<- [::auth.subs/branch-operating-days]
 (fn [[branch-id days-by-org-unit] _]
   (when (seq days-by-org-unit)
     (if branch-id
       (some-> (or (get days-by-org-unit (keyword (str branch-id)))
                   (get days-by-org-unit (str branch-id)))
               set)
       (into #{} (mapcat identity) (vals days-by-org-unit))))))
